import { render, staticRenderFns } from "./cpzx.vue?vue&type=template&id=36ad141c&scoped=true&"
import script from "./cpzx.vue?vue&type=script&lang=js&"
export * from "./cpzx.vue?vue&type=script&lang=js&"
import style0 from "./cpzx.vue?vue&type=style&index=0&id=36ad141c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad141c",
  null
  
)

export default component.exports